<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.messageTracking") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm"><span>{{$t('tlt.administration')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm/integrationMessage"><span>{{$t('tlt.messageTracking')}}</span></router-link></li>
                </ul>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form>
                                <mes-filter entity="integrationMessage" />
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="integrationMessageResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <mmf-table  entity="integrationMessage"
                                        inline-actions-disabled singleChoice>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <b-modal id="modalRequestResponse" ref="modalRequestResponse"
        lazy centered title="" size="lg">
            <codemirror v-model="displayedRequestResponse"
            ref="myCm"
            :options="cmOptions">
            </codemirror>
        </b-modal>
    </div>
</template>

<style>
/* .rtl { direction: rtl; } */
/* .rtl { direction: unset; } */

.tooltip-inner {
  /* background-color: linen !important; */
    /* color: #000 !important; */
    /* font-weight: bolder; */
    min-width: 250px;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import {gridFields}  from "@/model/adm/IntegrationMessage";
import MesFilter from "@/components/MesFilter";
import MmfTable from "@/components/MmfTable";

import { codemirror } from 'vue-codemirror'
import * as moment from 'moment';
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/yaml/yaml.js'
import 'codemirror/mode/properties/properties.js'
import 'codemirror/theme/base16-dark.css'
import 'codemirror/theme/eclipse.css'

export default {
  data () {
    return {
      displayedRequestResponse: "",
      defaultDateFrom: moment().add(-3, 'days'),
      defaultDateTo: new moment(),
      cmOptions: {
        tabSize: 4,
        mode: 'text/xml',
        theme: 'eclipse',
        lineNumbers: true,
        line: true
      },
      toolTipData: [

      ]
      
    }
  },
  name: "integrationMessageList",
  computed: {
        //define the state of rows and fields of grid
        ...mapState({
            rows: state => state.integrationMessage.rows,
            checkedItems: state => state.integrationMessage.checkedItems,
            tableColumns: gridFields
        })
  },
  methods: {
        toggleAll(checked) {
            if(!checked){
                this.$store.commit( "integrationMessage/checkedItems", [] );
                return;
            }

            var auxVector = []
            for (let i in this.$store.state.integrationMessage.rows)
                if( this.$store.state.integrationMessage.rows[i].status === 'E' )
                    auxVector.push(this.$store.state.integrationMessage.rows[i].id)

           this.$store.commit( "integrationMessage/checkedItems", auxVector );
        },
      showRequestResponse(item, type){
          if( type == "req" ){
              this.displayedRequestResponse = item.request
          }else{
              this.displayedRequestResponse = item.response
          }
          this.$refs.modalRequestResponse.show();
      },
      showRelatedMessages(item){
        var me = this;

        this.$store.dispatch("api/get", {url: "integrationMessage/findRelations/"+item.id}, {root: true})
        .then(function(data){
            me.toolTipData = data;
            me.$root.$emit('bv::hide::tooltip');// closing all tooltips
            if(!me.$refs['tooltipRelations_' + item.id].mmfVisible){
                me.$refs['tooltipRelations_' + item.id].$emit('open');
                me.$refs['tooltipRelations_' + item.id].mmfVisible = true;
            }else{
                me.$refs['tooltipRelations_' + item.id].$emit('close');
                me.$refs['tooltipRelations_' + item.id].mmfVisible = false;
            }
        })
      },
    ...mapActions("integrationMessage", ["reprocessMessage"]),
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"])
  },
  components: {
    MesFilter,
    MmfTable,
    codemirror
  }
};
</script>
